<template>
  <section>
    <div class="box">
      <div v-for="(k, index) in kosaku" :key="index">
        <browse-kosaku-view :data="k.data" :imageUrl="k.imageUrl" />
      </div>
    </div>
  </section>
</template>

<script>
import BrowseKosakuView from '../components/BrowseKosakuView.vue'

export default {
  components: {
    BrowseKosakuView,
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return !this.token;
    },
    authorized () {
      return !this.unauthorized;
    },
    kosaku () {
      return this.$store.state.gaiyoPages;
    },
  },
  mounted () {
    this.$store.commit('setPrinting', true);
    setTimeout(() => {
      window.print();
      this.$store.commit('setPrinting', false);
      this.$router.back();
    }, 3000);
  },
}
</script>

<style lang="scss" scoped>
/*
* {
  padding: 0;
}
section {
  margin: 0;
  padding: 0;
}
*/
.box {
  background-color: white;
}
@media print {
  @page {
    //size: A4 portrait !important;
    size: auto !important;
    margin: 0mm;
  }
  .box {
    //width: 200mm;
    //height: auto;
    //width: calc(210mm - 16mm);
    height: calc(296m - 36mm);
    //width: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
}
</style>
